export const getEventsMenuItems = ({ page, isEventPage, isEventsPage, isNewEventPage }) => {
  const menuGroup = []

  menuGroup.push({
    img: 'events',
    title: 'Events',
    href: `/events`,
    active: isEventsPage || isNewEventPage,
    visible: true,
    open: isEventPage,
  })

  return menuGroup
}
